export default __webpack_public_path__ + "static/media/mittakortti.19a7beae.svg";